import Vue from 'vue';

Vue.directive('append-pac-here', function (el, binding, vnode) {
  el.addEventListener('focus', function () {
    var content = window.document.getElementsByClassName('pac-container')[0];
    if (content) el.parentElement.appendChild(content);
  });
});